(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('EnsambleIbqDeleteController',EnsambleIbqDeleteController);

    EnsambleIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ensamble'];

    function EnsambleIbqDeleteController($uibModalInstance, entity, Ensamble) {
        var vm = this;

        vm.ensamble = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ensamble.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
